import {useLocation} from "react-router-dom";
import {detectPathUrl} from "./detectPathUrl";

// top Navbar
const useShowNavbar = () => {
    const {pathname} = useLocation();
    const hideRoutes = [detectPathUrl('app/report'),
                                detectPathUrl('app/edit'),
                                detectPathUrl('app/scan')];
    return hideRoutes.filter((item) => item === pathname).length === 0;
};

export default useShowNavbar;

// navigation bottom
export const HidingNavigation = () => {
    const { pathname } = useLocation();
    const hideRoutes = [detectPathUrl('app/report')];

    return hideRoutes.filter((item) => item === pathname).length > 0 ? 'hide' : 'show';
};
